<template>
  <div class="marathon_rankListCard">
    <span
      class="rankList_item"
      v-for="item in datas.data.dataList"
      :key="item.rank"
    >
      <span class="rankItem_left">
        <span class="left_rank" v-text="item.rank"></span>
        <span class="left_infor">
          <span class="leftInfor_name" v-text="item.athleteName"></span>
          <span class="leftInfor_num" v-text="item.athleteNum"></span>
        </span>
      </span>
      <span class="rankItem_right" v-text="item.num"></span>
    </span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'marathon_rankListCard',
  mixins: [cup_base_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
}
</script>

<style lang="scss" scoped>
.marathon_rankListCard {
  width: 100%;
  .rankList_item {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.694vw 1.388vw 0.694vw 0.694vw;
    &:first-child {
      .rankItem_left {
        .left_rank {
          background-color: var(--mixtmt_subColor3_1);
        }
      }
    }
    .rankItem_left {
      width: 60%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .left_rank {
        width: 1.388vw;
        height: 1.388vw;
        background-color: var(--mixtmt_mainColor6);
        color: var(--mixtmt_whiteColor);
        font-size: 0.972vw;
        line-height: 1.388vw;
        text-align: center;
        border-radius: 50%;
      }
      .left_infor {
        width: calc(100% - 1.388vw);
        padding: 0 0.694vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        .leftInfor_name {
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 0.972vw;
          line-height: 1.11vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
        .leftInfor_num {
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 0.833vw;
          line-height: 1.11vw;
          color: var(--mixtmt_greyColor4);
        }
      }
    }
    .rankItem_right {
      width: 40%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      color: var(--mixtmt_subColor3_1);
      font-size: 0.972vw;
      line-height: 1.11vw;
    }
  }
}
#marathon_broadcastList {
  .marathon_rankListCard {
    width: 60%;
    padding: 2.083vw;
  }
}
</style>
